import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout.jsx';
import DashboardLayout from '../layouts/DashboardLayout.jsx';
import ProtectedRoute from './ProtectedRoute.jsx';
import PublicRoute from './PublicRoute.jsx';
import Loader from '../components/common/Loader.jsx';

const Home = lazy(() => import('../pages/Home.jsx'));
const About = lazy(() => import('../pages/About.jsx'));
const Services = lazy(() => import('../pages/Services.jsx'));
const Solutions = lazy(() => import('../pages/Solutions.jsx'));
const Technologies = lazy(() => import('../pages/Technologies.jsx'));
const Portfolio = lazy(() => import('../pages/Portfolio.jsx'));
const Careers = lazy(() => import('../pages/Careers.jsx'));
const Contact = lazy(() => import('../pages/Contact.jsx'));
const Login = lazy(() => import('../pages/Login.jsx'));
const Signup = lazy(() => import('../pages/Signup.jsx'));
const Dashboard = lazy(() => import('../pages/Dashboard.jsx'));
const Blog = lazy(() => import('../pages/Blog.jsx'));
const NotFound = lazy(() => import('../pages/NotFound.jsx'));

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<MainLayout />}> 
      <Route index element={<Home />} />
      <Route path="about" element={<About />} />
      <Route path="services" element={<Services />} />
      <Route path="solutions" element={<Solutions />} />
      <Route path="technologies" element={<Technologies />} />
      <Route path="portfolio" element={<Portfolio />} />
      <Route path="careers" element={<Careers />} />
      <Route path="contact" element={<Contact />} />
      <Route path="blog" element={<Blog />} />
      <Route path="login" element={<PublicRoute><Login /></PublicRoute>} />
      <Route path="signup" element={<PublicRoute><Signup /></PublicRoute>} />
      <Route path="*" element={<NotFound />} />
    </Route>
    <Route path="/dashboard" element={<ProtectedRoute><DashboardLayout /></ProtectedRoute>}>
      <Route index element={<Dashboard />} />
    </Route>
  </Routes>
);

export default AppRoutes;
